import { makeStyles } from "@material-ui/core";

export const RankingDateFiltersStyle = makeStyles((theme) => ({
    wrapper: {
        height: '500px'
    },
    searchWrapper: {
        padding: '1em'
    },
    timeFilterButton: {
        borderRadius: '7em / 7em'
    }
}));